import React, { useEffect, useState } from 'react';
import { getUserAstroDualReview } from '../openai';
import { realHoroscopes } from '../realHoroscopes';
import { db } from '../firebase';
import { collection, query, where, getDocs, setDoc, doc } from 'firebase/firestore';

const zodiacRanges = [
  { sign: 'Capricorn', start: '01-01', end: '01-19' },
  { sign: 'Aquarius', start: '01-20', end: '02-18' },
  { sign: 'Pisces', start: '02-19', end: '03-20' },
  { sign: 'Aries', start: '03-21', end: '04-19' },
  { sign: 'Taurus', start: '04-20', end: '05-20' },
  { sign: 'Gemini', start: '05-21', end: '06-20' },
  { sign: 'Cancer', start: '06-21', end: '07-22' },
  { sign: 'Leo', start: '07-23', end: '08-22' },
  { sign: 'Virgo', start: '08-23', end: '09-22' },
  { sign: 'Libra', start: '09-23', end: '10-22' },
  { sign: 'Scorpio', start: '10-23', end: '11-21' },
  { sign: 'Sagittarius', start: '11-22', end: '12-21' },
  { sign: 'Capricorn', start: '12-22', end: '12-31' },
];

function getZodiacSign(birthdate) {
  if (!birthdate) return '';
  const [year, month, day] = birthdate.split('-').map(Number);
  const mmdd = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  for (const range of zodiacRanges) {
    if (mmdd >= range.start && mmdd <= range.end) {
      return range.sign;
    }
  }
  return '';
}

// Fun lines are sourced from dailyFunLines (fetched once per day), not generated per user.
function TeamPerformanceReview({ members, onSeriousReviews, dailyFunLines }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function fetchReviews() {
      setLoading(true);
      const results = [];
      const seriousArr = [];
      const today = new Date().toISOString().slice(0, 10);
      for (const m of members) {
        const sign = getZodiacSign(m.birthdate);
        let serious = '';
        try {
          // Check Firestore for cached review
          const q = query(collection(db, 'user_reviews'), where('userId', '==', m.id), where('date', '==', today));
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            const data = querySnapshot.docs[0].data();
            serious = data.serious || '';
          } else {
            // Fetch from OpenAI and cache
            const dual = await getUserAstroDualReview({ name: m.name, birthdate: m.birthdate });
            serious = dual.serious;
            await setDoc(doc(db, 'user_reviews', `${m.id}_${today}`), {
              userId: m.id,
              date: today,
              serious,
              sign,
            });
          }
          if (!cancelled) results.push({ name: m.name, sign, serious });
          seriousArr.push(`${m.name}: ${serious}`);
        } catch {
          if (!cancelled) results.push({ name: m.name, sign, serious: 'შეფასების მიღება ვერ მოხერხდა.' });
        }
      }
      if (!cancelled) setReviews(results);
      setLoading(false);
      if (onSeriousReviews) onSeriousReviews(seriousArr);
    }
    if (members.length > 0) fetchReviews();
    else setReviews([]);
    return () => { cancelled = true; };
  }, [members, onSeriousReviews]);

  if (!members || members.length === 0) {
    return <div className="text-gray-400">Add team members to see their cosmic review!</div>;
  }
  if (loading) {
    return <div className="text-gray-500">იტვირთება პერსონალური ასტროლოგიური შეფასებები...</div>;
  }
  return (
    <div className="w-full max-w-6xl mx-auto">
      <ul className="space-y-2">
        {reviews.map((r, i) => {
          let funLine = '';
          if (dailyFunLines && dailyFunLines[r.sign]) {
            const roleKey = (members[i]?.role || 'developer').toLowerCase();
            funLine = dailyFunLines[r.sign][roleKey] || '';
            // Remove first word and colon (e.g., 'developer:') if present
            funLine = funLine.replace(/^\s*\w+:\s*/i, '');
          }
          return (
            <li key={i} className="flex flex-col sm:flex-row sm:items-center gap-2 bg-[#181c2a] border border-orange-300 rounded-lg shadow p-4">
              <span className="font-semibold min-w-[120px] max-w-[220px] truncate text-ellipsis text-orange-200" title={r.name}>{r.name}</span>
              <span className="text-orange-300 min-w-[80px]">({r.sign})</span>
              <span className="italic text-orange-100 flex-[3_1_0%] min-w-0">- {r.serious}</span>
              {funLine && (
                <span className="text-orange-400 flex-1">{funLine}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default TeamPerformanceReview; 